import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'fixedDecimal',
  standalone: true
})
export class FixedDecimalPipe implements PipeTransform {
  transform(value: number | null | undefined, decimalPlaces: number): string {
    if (value === null || value === undefined || isNaN(value)) {
      return '';
    }

    return value.toFixed(decimalPlaces);
  }
}
